import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import { Supplier } from '../../features/selfservice/suppliers/data'
import i18n from '../../utils/i18n'
import { ActiveBodyTemplate } from './ActiveBodyTemplate'

export const ActiveFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const status: Supplier['Status'][] = ['active', 'inactive']

  const valueTemplate = (option: Supplier['Status'], props: any) => {
    if (option) {
      return ActiveBodyTemplate(option)
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: Supplier['Status']) =>
    ActiveBodyTemplate(option)

  return (
    <Dropdown
      value={options.value}
      options={status}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.searchStatus')}
    />
  )
}
